<div *ngIf="people && people.length > 0" class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate>
    <div class="ir-modal--title">
      <div class="ir-line--right"></div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'accessrights.edittitle' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td width="20%">
              <h2>
                <span>{{ 'accessrights.users' | translate }}</span>
              </h2>
            </td>
            <td>
              <select name="personId" class="ir-form-set" [(ngModel)]="personId">
                <option *ngFor="let person of people" [value]="person.id">{{ person.name }}</option>
              </select>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td colspan="2" style="text-align: right">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'accessrights.name' | translate }}</span>
        </h2>
        <table class="ir-plugin-table">
          <tbody style="vertical-align: top">
            <tr class="th-plugin-line--subheader">
              <td width="20%"><span>User</span></td>
              <td *ngFor="let col of columns">
                <span>{{ col }}</span>
              </td>
            </tr>
            <tr class="th-plugin-line--content" *ngFor="let item of accessRights; let i = index">
              <td valign="middle">
                <span>{{ getPersonName(item) }}</span>
              </td>
              <td valign="middle" *ngFor="let col of columns" class="" (click)="updateAccessRights(item, col)">
                <i class="material-icons" *ngIf="!hasRight(item, col)">check_box_outline_blank</i>
                <i class="material-icons" *ngIf="hasRight(item, col)">check_box</i>
              </td>
              <td valign="middle" align="right" class="th-plugin-line--remove">
                <i class="material-icons" (click)="remove(i)">remove_circle</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="save()"
            *ngIf="!processing"
            type="submit"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
